import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="inline-edit"
//
// Shows a read-only value with a pencil affordance; clicking it toggles
// between the plain-text display and the editable field so the user can amend
// the value in place (e.g. adjusting the context before a redo).
export default class extends Controller {
  static targets = ["display", "edit", "input"]

  toggle() {
    // Entering edit mode when the field is currently hidden.
    const editing = this.editTarget.classList.contains("hidden")
    this.editTarget.classList.toggle("hidden", !editing)
    this.displayTarget.classList.toggle("hidden", editing)
    if (editing && this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }
}
